import { Stack, chipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const INFO_CARD_PREFIX = "InfoCard";

export const infoCardClasses = {
  root: `${INFO_CARD_PREFIX}-root`,
};

export const InfoCard = styled(Stack)(({ theme }) => ({
  [`&.${infoCardClasses.root}`]: {
    backgroundColor: theme.palette.surface.main,
    borderRadius: 4,
    width: 225,
    padding: theme.spacing(2),
    gap: theme.spacing(1),
    [`& .${chipClasses.root}`]: {
      alignSelf: "start",
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      [`& .${chipClasses.label}:first-letter`]: {
        textTransform: "uppercase",
      },
    },
  },
}));
